import React from 'react'
import { Navigate } from 'react-router-dom'

import { useTeamManager } from '../../hooks/useTeamManager'

const TeamRoute = ({ user, children }) => {
  const { canManageTeam, resolved } = useTeamManager(user)

  if (!resolved) return null

  return canManageTeam ? children : <Navigate to="/" replace />
}

export default TeamRoute
